module.exports = __webpack_public_path__ + "img/fgf.38f389eb.webp";